import { all } from 'redux-saga/effects';

import bundleSaga from './bundle/saga';
import AuthSaga from "./auth/saga";
import ProductMappingSaga from "./product_mapping/saga";
import VolumeDiscountSaga from "./volume_discount/saga";

export default function* rootSaga() {
    yield all([bundleSaga(), AuthSaga(), ProductMappingSaga(), VolumeDiscountSaga()]);
}